<template>
  <div class="max-w-md mx-auto" v-if="logged === false">
    <form class="stack" novalidate @submit.prevent="submit(formOptions)">
      <input-text
        :label="$t('general.username')"
        required
        @update-value="updateForm('username', $event)"
      />
      <input-text
        type="password"
        :label="$t('general.password')"
        required
        :validations="[{ validation: 'length', type: 'min', value: 8 }]"
        @update-value="updateForm('password', $event)"
      />
      <input-text
        type="password"
        :label="$t('register.password_repeat')"
        required
        :validations="[{ validation: 'length', type: 'min', value: 8 }]"
        @update-value="updateForm('password2', $event)"
      />
      <input-text
        :label="$t('general.email')"
        :validations="[{ validation: 'email' }]"
        @update-value="updateForm('email', $event)"
      />
      <info :title="$t('general.email')" toggleable>
        {{ $t("register.email_info") }}
      </info>
      <div>
        <input-range
          :label="$t('users.settings.fontsize')"
          value="1"
          @update-value="setFontsize"
        />
        <div
          class="self-center"
          :class="{
            'text-lg': fontSize === 'lg',
            'text-xl': fontSize === 'xl',
          }"
        >
          {{ fontSizeTranslation }}
        </div>
      </div>
      <div class="text-right">
        <wd-button :sending="sending">{{ $t("general.send") }}</wd-button>
      </div>
      <div class="text-gray-700 text-sm leading-snug mt-2">
        <p class="font-light">{{ $t("register.got_account") }}</p>
        <p class="text-primary-500">
          <router-link to="/login">{{ $t("register.to_login") }}</router-link>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
const FormMixin = require("@/mixins/FormMixin").default;
const Info = require("@/modules/core/components/Info.vue").default;
const InputRange = require("@/modules/input/components/InputRange.vue").default;

export default {
  name: "RegisterForm",
  mixins: [FormMixin],
  data() {
    return {
      fontSize: "lg",
      fontSizeTranslation: this.$t("users.settings.fontsizes.lg"),
    };
  },
  components: {
    Info,
    InputRange,
  },
  computed: {
    logged: function() {
      return this.$store.getters["auth/logged"];
    },
  },
  methods: {
    setFontsize(Size) {
      switch (Size) {
        case "0":
          this.fontSize = "default";
          this.fontSizeTranslation = this.$t(
            "users.settings.fontsizes.default"
          );
          break;
        case "1":
          this.fontSize = "lg";
          this.fontSizeTranslation = this.$t("users.settings.fontsizes.lg");
          break;
        case "2":
          this.fontSize = "xl";
          this.fontSizeTranslation = this.$t("users.settings.fontsizes.xl");
          break;

        default:
          this.fontSize = "default";
          this.fontSizeTranslation = this.$t(
            "users.settings.fontsizes.default"
          );
          break;
      }
      this.formData.fontsize = this.fontSize;
    },
  },
  created() {
    this.formOptions = {
      custom: true,
      type: "auth",
      call: "register",
      action: () => {
        this.goTo("/");
        this.popup({
          type: "success",
          title: "Registrierung erfolgreich",
          text: "Du kannst dich jetzt einloggen.",
        });
      },
    };
  },
};
</script>
